import React, {Component} from 'react';
import {connect} from 'react-redux';
import DisabledPlayerIfGameLockedSpecification from 'specifications/disabled-player-if-game-locked-specification';

class LockedPlayerGameMarker extends Component {
    render() {
        const {sportConfig, games, player} = this.props;

        const isPlayerDisabled = DisabledPlayerIfGameLockedSpecification.isSatisfiedBy({
            sportConfig,
            games,
            player,
        });

        if (isPlayerDisabled) {
            return <i className="fa fa-lock" />;
        }

        return null;
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {games},
    } = state;

    return {
        sportConfig,
        games,
    };
}

export default connect(mapStatesToProps)(LockedPlayerGameMarker);
